import React, { useContext } from "react";
import PageHeading from "../PageHeading";
import MedicalCampList from "./MedicalCampList";
import AddMedicalCamp from "./AddMedicalCamp";
import MedicalCampContext from "../../context/reportContext";

const MedicalCampTab = () => {
  const medicalCampContext = useContext(MedicalCampContext);

  const handleModal = () => {
    medicalCampContext.updateOpenModal(true);
  };

  return (
    <>
      <PageHeading
        pageTitle="Medical Camp Records"
        pageModalTitle="+ Add Medical Camp Records"
        pageModalOpen={handleModal}
      />
      <div className="user-table-wrapper mt-5">
        <MedicalCampList />
      </div>
      <AddMedicalCamp isOpen={medicalCampContext.isOpenModal} />
    </>
  );
};

export default MedicalCampTab;
